import config from '../../../../config';
import Request from '../../../Request';

export default function checkExisting(organizationId, values, onSuccess, onFailure) {
  return Request.post(`${config.apiUrl}/public/storefronts/${organizationId}/locations/check_existing`, {
    location: values
  }, onSuccess, onFailure);
}